export default {
    state: () => ({
        data: { }
    }),
    mutations: {
        ['breadcrumb/setState'](state, payload) {
            state.data = {...payload,}
        },
    },
    actions: {

    },
}
